// Translations for the portfolio

export const translations = {
  en: {
    // Header
    nav: {
      about: 'About',
      skills: 'Skills',
      projects: 'Projects',
      contact: 'Contact',
      contactBtn: 'Get in Touch'
    },
    // Hero
    hero: {
      status: 'Open for new projects',
      greeting: 'Hello, I am',
      title: 'Software Developer',
      tagline: 'Turning ideas into reality through code',
      projectsBtn: 'View Projects',
      contactBtn: 'Get in Touch'
    },
    // About
    about: {
      label: 'About Me',
      title: 'Who',
      titleHighlight: 'Am I?',
      bio: 'As a passionate software developer and entrepreneur, I focus on modern web technologies and user experience driven projects. Clean code and innovative solutions are essential to me.',
      bio2: 'I continuously learn and improve myself to achieve the best results in every project. Adapting to new technologies and creating innovative solutions is my passion.',
      location: 'Netherlands',
      freelance: 'Available for freelance',
      highlights: {
        cleanCode: {
          title: 'Clean Code',
          description: 'Writing clean, readable and maintainable code'
        },
        modernTech: {
          title: 'Modern Tech',
          description: 'Following and implementing the latest technologies'
        },
        performance: {
          title: 'Performance',
          description: 'Developing fast and optimized applications'
        },
        userFocus: {
          title: 'User Focus',
          description: 'Always prioritizing user experience'
        }
      }
    },
    // Skills
    skills: {
      label: 'Skills',
      title: 'Technology',
      titleHighlight: 'Stack'
    },
    // Projects
    projects: {
      label: 'Projects',
      title: 'Recent',
      titleHighlight: 'Work',
      code: 'Code',
      demo: 'Demo',
      moreBtn: 'More on GitHub'
    },
    // Contact
    contact: {
      label: 'Contact',
      title: "Let's Work",
      titleHighlight: 'Together',
      description: "I'm always excited for new projects. If you have an idea or just want to say hello, get in touch!",
      location: 'Location',
      social: 'Follow on social media:',
      form: {
        name: 'Your Name',
        namePlaceholder: 'John Doe',
        email: 'Email',
        emailPlaceholder: 'john@example.com',
        subject: 'Subject',
        subjectPlaceholder: 'About a project',
        message: 'Your Message',
        messagePlaceholder: 'Write your message here...',
        submit: 'Send Message'
      }
    },
    // Footer
    footer: {
      madeWith: 'Made with',
      in: 'in Netherlands'
    }
  },
  nl: {
    // Header
    nav: {
      about: 'Over Mij',
      skills: 'Vaardigheden',
      projects: 'Projecten',
      contact: 'Contact',
      contactBtn: 'Neem Contact Op'
    },
    // Hero
    hero: {
      status: 'Open voor nieuwe projecten',
      greeting: 'Hallo, ik ben',
      title: 'Software Developer',
      tagline: 'Ideeën omzetten in werkelijkheid door code',
      projectsBtn: 'Bekijk Projecten',
      contactBtn: 'Neem Contact Op'
    },
    // About
    about: {
      label: 'Over Mij',
      title: 'Wie',
      titleHighlight: 'Ben Ik?',
      bio: 'Als gepassioneerde softwareontwikkelaar en ondernemer richt ik mij op moderne webtechnologieën en gebruikerservaring gerichte projecten. Schone code en innovatieve oplossingen zijn voor mij essentieel.',
      bio2: 'Ik leer en verbeter mezelf voortdurend om de beste resultaten in elk project te behalen. Aanpassen aan nieuwe technologieën en innovatieve oplossingen creëren is mijn passie.',
      location: 'Nederland',
      freelance: 'Beschikbaar voor freelance',
      highlights: {
        cleanCode: {
          title: 'Schone Code',
          description: 'Schone, leesbare en onderhoudbare code schrijven'
        },
        modernTech: {
          title: 'Moderne Tech',
          description: 'De nieuwste technologieën volgen en implementeren'
        },
        performance: {
          title: 'Prestaties',
          description: 'Snelle en geoptimaliseerde applicaties ontwikkelen'
        },
        userFocus: {
          title: 'Gebruikersfocus',
          description: 'Altijd gebruikerservaring prioriteren'
        }
      }
    },
    // Skills
    skills: {
      label: 'Vaardigheden',
      title: 'Technologie',
      titleHighlight: 'Stack'
    },
    // Projects
    projects: {
      label: 'Projecten',
      title: 'Recent',
      titleHighlight: 'Werk',
      code: 'Code',
      demo: 'Demo',
      moreBtn: 'Meer op GitHub'
    },
    // Contact
    contact: {
      label: 'Contact',
      title: 'Laten We',
      titleHighlight: 'Samenwerken',
      description: 'Ik ben altijd enthousiast voor nieuwe projecten. Als je een idee hebt of gewoon hallo wilt zeggen, neem contact op!',
      location: 'Locatie',
      social: 'Volg op social media:',
      form: {
        name: 'Uw Naam',
        namePlaceholder: 'Jan de Vries',
        email: 'E-mail',
        emailPlaceholder: 'jan@voorbeeld.nl',
        subject: 'Onderwerp',
        subjectPlaceholder: 'Over een project',
        message: 'Uw Bericht',
        messagePlaceholder: 'Schrijf uw bericht hier...',
        submit: 'Verstuur Bericht'
      }
    },
    // Footer
    footer: {
      madeWith: 'Gemaakt met',
      in: 'in Nederland'
    }
  },
  tr: {
    // Header
    nav: {
      about: 'Hakkımda',
      skills: 'Yetenekler',
      projects: 'Projeler',
      contact: 'İletişim',
      contactBtn: 'İletişime Geç'
    },
    // Hero
    hero: {
      status: 'Yeni projelere açık',
      greeting: 'Merhaba, ben',
      title: 'Software Developer',
      tagline: 'Kod ile hayalleri gerçeğe dönüştürüyorum',
      projectsBtn: 'Projelerimi Gör',
      contactBtn: 'İletişime Geç'
    },
    // About
    about: {
      label: 'Hakkımda',
      title: 'Kim',
      titleHighlight: 'Ben?',
      bio: 'Tutkulu bir yazılım geliştirici ve girişimci olarak, modern web teknolojileri ve kullanıcı deneyimi odaklı projeler üzerinde çalışıyorum. Clean code ve innovative solutions benim için vazgeçilmez.',
      bio2: 'Her projede en iyi sonucu elde etmek için sürekli öğreniyor ve kendimi geliştiriyorum. Yeni teknolojilere adapte olmak ve innovative çözümler üretmek benim için bir tutku.',
      location: 'Hollanda',
      freelance: 'Freelance için müsait',
      highlights: {
        cleanCode: {
          title: 'Clean Code',
          description: 'Temiz, okunabilir ve sürdürülebilir kod yazıyorum'
        },
        modernTech: {
          title: 'Modern Tech',
          description: 'En güncel teknolojileri takip ediyor ve uyguluyorum'
        },
        performance: {
          title: 'Performance',
          description: 'Hızlı ve optimize edilmiş uygulamalar geliştiriyorum'
        },
        userFocus: {
          title: 'User Focus',
          description: 'Kullanıcı deneyimini her zaman ön planda tutuyorum'
        }
      }
    },
    // Skills
    skills: {
      label: 'Yetenekler',
      title: 'Teknoloji',
      titleHighlight: 'Stack'
    },
    // Projects
    projects: {
      label: 'Projeler',
      title: 'Son',
      titleHighlight: 'Çalışmalarım',
      code: 'Kod',
      demo: 'Demo',
      moreBtn: "GitHub'da Daha Fazla"
    },
    // Contact
    contact: {
      label: 'İletişim',
      title: 'Birlikte',
      titleHighlight: 'Çalışalım',
      description: 'Yeni projeler için her zaman heyecanlıyım. Eğer bir fikriniz varsa veya sadece merhaba demek istiyorsanız, benimle iletişime geçin!',
      location: 'Konum',
      social: 'Sosyal medyada takip edin:',
      form: {
        name: 'Adınız',
        namePlaceholder: 'John Doe',
        email: 'Email',
        emailPlaceholder: 'john@example.com',
        subject: 'Konu',
        subjectPlaceholder: 'Proje hakkında',
        message: 'Mesajınız',
        messagePlaceholder: 'Mesajınızı buraya yazın...',
        submit: 'Mesaj Gönder'
      }
    },
    // Footer
    footer: {
      madeWith: 'Made with',
      in: 'in Hollanda'
    }
  }
};

export const getTranslation = (lang, path) => {
  const keys = path.split('.');
  let result = translations[lang] || translations.en;
  for (const key of keys) {
    result = result?.[key];
  }
  return result || path;
};
